(ns common.response-handler.core
  (:require [common.modal.dialog :refer [response-dialog]]
            [common.modal.view :refer [defmodal]]
            [common.url :as url]
            [re-frame.core :as rf]))

(def default-error-message "Something went wrong.")
(def default-success-message "Success.")

(defn full-error-message
  [event response]
  (str "Response: " response
       "\n\n"
       "Event: " event
       "\n\n"
       "Page URL: " (url/current-uri)))

(defn handle-success-event
  [{:keys [display-type entity-name message full-message]
    :or {display-type :toaster
         message default-success-message}}]
  (case display-type
    :modal [:modal/open {:id :response-handler/success-modal
                         :props {:entity-name entity-name
                                 :message message}}]
    :toaster [:toaster-bus/add {:type :success
                                :message message
                                :full-message full-message}]
    :silent nil))

(defn handle-error-event
  [{:keys [display-type entity-name message event response]
    :or {display-type :toaster}}]
  (let [message* (or (get-in response [:error :message])
                     (get-in response [:value :error :message])
                     message
                     default-error-message)]
    (case display-type
      :modal [:modal/open {:id :response-handler/error-modal
                           :props {:entity-name entity-name
                                   :message message*}}]
      :toaster [:toaster-bus/add (merge {:type :error
                                         :message message*}
                                        (when (not (nil? response))
                                          {:full-message (full-error-message event response)}))]
      :silent nil)))

"Global response handling event.
  Shows a message of the provided type and containing the provided message.

   The following properties can be passed as a map:
   | key               | description
   |-------------------|-----------------------------------------------------
   | `:type`           | Either :success or :error
   | `:display-type`   | Either :modal or :toaster or :silent (defaults to :toaster)
   | `:entity-name`    | The name of the entity. Influences the title.
   | `:message`        | The message to be shown. Errors default to 'Something went wrong.'
   | `:reponse`        | The response from which the backend message will try to be retrieved

  The order of priority for the messages is:
  - message from response
  - given (fallback) message
  - default message

  e.g.
  (rf/dispatch [:response-handler/handle-response {:entity-name 'Foo'
                                                   :type :error
                                                   :display-type :modal
                                                   :response response}])

  The unused params here (_db and _event) as well as the full response can potentially be used for logging."

(rf/reg-event-fx :response-handler/handle-response
  (fn [{:keys [_db]} [_event-name {:keys [type] :as props}]]
    {:dispatch-n [(case type
                    :success (handle-success-event props)
                    :error (handle-error-event props))]}))

(defmodal error-modal :response-handler/error-modal
  [{:keys [entity-name message]}]
  [response-dialog
   {:title (str "Error - " entity-name)
    :modifier :error
    :message message}])

(defmodal success-modal :response-handler/success-modal
  [{:keys [entity-name message]}]
  [response-dialog
   {:title (str "Success - " entity-name)
    :modifier :success
    :message message}])
